import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard } from '@fortawesome/pro-solid-svg-icons/faCreditCard';

import React from 'react';

import classnames from 'classnames';

import { AutoCompleteField } from '../../../constants/autocomplete-field';
import { CREDIT_CARD_FIELDS } from '../constants';
import CreditCardInput from '../credit-card-input';
import useCreditCardField from '../use-credit-card-field';

import style from './style.module.less';

const CreditCardNumber = () => {
  const { error } = useCreditCardField(CREDIT_CARD_FIELDS.CARD_NUMBER);

  return (
    <div className={style.container}>
      <CreditCardInput
        autoComplete={AutoCompleteField.CCNumber}
        className={style['number-input']}
        data-private
        field={CREDIT_CARD_FIELDS.CARD_NUMBER}
      />
      <FontAwesomeIcon className={classnames(style['credit-card'], { [style.error]: !!error })} icon={faCreditCard} />
    </div>
  );
};

export default CreditCardNumber;
